/* tslint:disable */
import {
  UserProfile,
  TenantCheckList
} from '../index';

declare var Object: any;
export interface CheckListInterface {
  "description"?: string;
  "status"?: string;
  "checked_by"?: string;
  "id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  tenants_check_list?: UserProfile[];
  tenantCheckLists?: TenantCheckList[];
}

export class CheckList implements CheckListInterface {
  "description": string;
  "status": string;
  "checked_by": string;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  tenants_check_list: UserProfile[];
  tenantCheckLists: TenantCheckList[];
  constructor(data?: CheckListInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `CheckList`.
   */
  public static getModelName() {
    return "CheckList";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of CheckList for dynamic purposes.
  **/
  public static factory(data: CheckListInterface): CheckList{
    return new CheckList(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'CheckList',
      plural: 'CheckLists',
      path: 'CheckLists',
      idName: 'id',
      properties: {
        "description": {
          name: 'description',
          type: 'string'
        },
        "status": {
          name: 'status',
          type: 'string'
        },
        "checked_by": {
          name: 'checked_by',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        tenants_check_list: {
          name: 'tenants_check_list',
          type: 'UserProfile[]',
          model: 'UserProfile',
          relationType: 'hasMany',
          modelThrough: 'TenantCheckList',
          keyThrough: 'tenant_id',
          keyFrom: 'id',
          keyTo: 'check_list_id'
        },
        tenantCheckLists: {
          name: 'tenantCheckLists',
          type: 'TenantCheckList[]',
          model: 'TenantCheckList',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'check_list_id'
        },
      }
    }
  }
}
